import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { fontSans, tokens } from './theme';

/**
 * Valeurs par défaut Chart.js alignées sur le thème RunnrZ Admin :
 * police Geist, axes discrets, info-bulles sombres.
 */
export const chartPalette = {
  accent: tokens.accent,
  blue: tokens.blue,
  green: '#2E9A5E',
  ink: tokens.ink,
  grey: '#B9B7B0',
  amber: '#C98A1B',
  red: tokens.red,
  lightAccent: '#F4CDBE',
  lightBlue: '#A9C1EC',
};

export const applyChartDefaults = () => {
  // Les vues sont chargées à la demande : on enregistre les plugins ici pour que
  // `defaults.plugins.legend/tooltip` existent avant d'être configurés.
  ChartJS.register(ArcElement, BarElement, CategoryScale, Filler, Legend, LinearScale, LineElement, PointElement, Title, Tooltip);
  ChartJS.defaults.font.family = fontSans;
  ChartJS.defaults.font.size = 11;
  ChartJS.defaults.color = tokens.muted;
  ChartJS.defaults.borderColor = tokens.lineSoft;
  ChartJS.defaults.plugins.legend.labels.usePointStyle = true;
  ChartJS.defaults.plugins.legend.labels.boxWidth = 8;
  ChartJS.defaults.plugins.legend.labels.boxHeight = 8;
  ChartJS.defaults.plugins.tooltip.backgroundColor = tokens.ink;
  ChartJS.defaults.plugins.tooltip.titleColor = '#FFFFFF';
  ChartJS.defaults.plugins.tooltip.bodyColor = '#E7E5E0';
  ChartJS.defaults.plugins.tooltip.footerColor = '#FFFFFF';
  ChartJS.defaults.plugins.tooltip.padding = 10;
  ChartJS.defaults.plugins.tooltip.cornerRadius = 8;
  ChartJS.defaults.plugins.tooltip.boxPadding = 4;
  ChartJS.defaults.elements.bar.borderRadius = 3;
  ChartJS.defaults.elements.line.borderWidth = 2;
  ChartJS.defaults.elements.point.radius = 0;
  ChartJS.defaults.elements.point.hoverRadius = 4;
};
